import { logout as logoutActionCreator } from '../store/iam/creators';
import { IAM_COOKIE_NAME } from '../settings/config';
import { removeCookie, defaultIamCookieAttributes } from '../utils/cookie';
import { backlinksApi } from '../backlinks/service';
import { trackedWebsitesApi } from '../trackedWebsites/service';
import { locationsAndLanguagesApi } from '../trackedWebsites/service';
import { topKeywordsApi } from '../topKeywords/service';
import { keywordResearchApi } from '../keywordResearch/service';
import { trackedKeywordsApi } from '../trackedKeywords/service';
import { siteSpeedApi } from '../siteSpeed/service';
import { siteOutageApi } from '../outage/service';
import { deepAnalysisApi } from '../deepAnalysis/service';
import { competitorDomainsApi } from '../competitorDomains/service';
import { analysisApi } from '../analysis/service';
import { whiteLabelApi } from '../whiteLabel/service';
import { salesApi } from '../sales/service';
import { AppDispatch } from '../store';

/**
 * Thunk action creator that, when dispatched, clears RTK Query entries and logs out the user
 * @param redirectTo
 * @returns
 */
export function logout(redirectTo = '/auth/login') {
    return (dispatch: AppDispatch) => {
        dispatch(logoutActionCreator());
        dispatch(backlinksApi.util.resetApiState());
        dispatch(trackedWebsitesApi.util.resetApiState());
        dispatch(locationsAndLanguagesApi.util.resetApiState());
        dispatch(topKeywordsApi.util.resetApiState());
        dispatch(keywordResearchApi.util.resetApiState());
        dispatch(trackedKeywordsApi.util.resetApiState());
        dispatch(siteSpeedApi.util.resetApiState());
        dispatch(siteOutageApi.util.resetApiState());
        dispatch(deepAnalysisApi.util.resetApiState());
        dispatch(competitorDomainsApi.util.resetApiState());
        dispatch(analysisApi.util.resetApiState());
        dispatch(whiteLabelApi.util.resetApiState());
        dispatch(salesApi.util.resetApiState());

        removeCookie(IAM_COOKIE_NAME, defaultIamCookieAttributes);
    };
}
